export const APP_ID = 'c5c7cfb6-21e0-4d8f-9234-716e26bd6b34';
export const PSI_LINK = `https://psi.ampify.io`;

export const SITE_METADATA_POLLING_DELAY = 30000;
export const PAGES_POLLING_DELAY = 30000;
